import { Link } from "react-router-dom";

export default function BuyingGuide() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          <div>
            <span className="text-xs font-label text-foreground-500 uppercase tracking-widest">
              Buying Guide
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-3 leading-tight">
              How to Use Kakobuy Spreadsheet to Find the Best Products
            </h2>
            <div className="mt-6 space-y-4 text-sm text-foreground-700 leading-relaxed">
              <p>
                The <strong>Kakobuy Spreadsheet</strong> is designed to make product discovery fast, safe, and efficient. Start by selecting your desired category from our comprehensive directory — whether you are looking for the latest sneaker releases, premium streetwear, or luxury accessories, every category is organized for easy navigation.
              </p>
              <p>
                Each product listing in the <strong>Kakobuy Spreadsheet</strong> includes the seller name, current price, and a seller rating from our verification system. Compare prices across multiple sellers to find the best deals on the products you want. Our rating system helps you identify the most reliable sellers quickly.
              </p>
              <p>
                Once you have found your product, click through to the seller&apos;s page on <strong>Kaspreadsheet</strong> to view detailed product information, additional photos, and complete your purchase. We recommend using an agent service for added buyer protection when ordering from Yupoo sellers.
              </p>
            </div>

            <div className="mt-6">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 text-sm font-label text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                Start Browsing the Spreadsheet
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div>
            <span className="text-xs font-label text-foreground-500 uppercase tracking-widest">
              Safety & Trust
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-3 leading-tight">
              Is Kakobuy Spreadsheet Safe?
            </h2>
            <div className="mt-6 space-y-4">
              <div className="flex gap-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-shield-check-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-heading font-semibold text-sm text-foreground-900">Buyer Protection</h4>
                  <p className="text-xs text-foreground-600 mt-1">Every seller in our directory undergoes a verification process. We monitor seller ratings and remove unreliable listings promptly.</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-eye-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-heading font-semibold text-sm text-foreground-900">QC Service Information</h4>
                  <p className="text-xs text-foreground-600 mt-1">Learn how to request quality check photos before your order ships. We guide you through the inspection process.</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-truck-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-heading font-semibold text-sm text-foreground-900">Shipping Insurance</h4>
                  <p className="text-xs text-foreground-600 mt-1">Protect your purchases with shipping insurance options available through most agents listed in our directory.</p>
                </div>
              </div>
              <div className="flex gap-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-alert-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-heading font-semibold text-sm text-foreground-900">Scam Prevention Tips</h4>
                  <p className="text-xs text-foreground-600 mt-1">We provide actionable tips to help you spot and avoid potential scams when shopping through Yupoo and similar platforms.</p>
                </div>
              </div>
            </div>

            <div className="mt-6">
              <Link
                to="/what-is-kakobuy-spreadsheet"
                className="inline-flex items-center gap-2 text-sm font-label text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
              >
                Read Our Complete Safety Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}